import { render, staticRenderFns } from "./DRS.vue?vue&type=template&id=3f298514"
import script from "./DRS.vue?vue&type=script&lang=js"
export * from "./DRS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports